// ============================================
// INFRASTRUCTURE - Feature Flags Repository
// ============================================

import { axiosClient } from './axios-client';
import type { FeatureFlagResponse, GranelCategoria, GranelTipo, GranelProductoEstandar, ProductoGranel } from '../../domain/entities';

export const featureFlagsRepository = {
  async checkFeature(feature: string): Promise<FeatureFlagResponse> {
    const { data } = await axiosClient.get<FeatureFlagResponse>(`/feature-flags/check?feature=${feature}`);
    return data;
  },
};

export const granelRepository = {
  async getCategorias(): Promise<GranelCategoria[]> {
    const { data } = await axiosClient.get<GranelCategoria[]>('/granel/categorias');
    return data;
  },

  async getTipos(categoriaId: number): Promise<GranelTipo[]> {
    const { data } = await axiosClient.get<GranelTipo[]>(`/granel/tipos?categoriaId=${categoriaId}`);
    return data;
  },

  async getProductosEstandar(tipoId: number): Promise<GranelProductoEstandar[]> {
    const { data } = await axiosClient.get<GranelProductoEstandar[]>(`/granel/productos-estandar?tipoId=${tipoId}`);
    return data;
  },

  async getProductos(): Promise<ProductoGranel[]> {
    const { data } = await axiosClient.get<ProductoGranel[]>('/granel/productos');
    return data;
  },
};
